import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const Tenancy = () => {
  const [address, setAddress] = useState('')
  const [rent, setRent] = useState('');
  const [deposit, setDeposit] = useState('');
  const [tenancyStart, setTenancyStart] = useState('');
  const [tenancyEnd, setTenancyEnd] = useState('');

  const { user } = useAuth(); // get user from context

  const loadTenancyDetails = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tenancy-details`, {
        method: 'POST',
        headers: {'Content-Type' : 'application/json'},
        body: JSON.stringify({user_id: user.id})
      });
      const result = await response.json();
      
      if (response.ok) {
        setAddress(result.address);
        setRent(result.rent);
        setDeposit(result.deposit);
        setTenancyStart(result.tenancy_start);
        setTenancyEnd(result.tenancy_end);
      } else {
        console.error(result.error);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  useEffect(() => {
    if (user && user.id) {
      loadTenancyDetails();
    }
  }, [user]);

  const downloadFile = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/download`, {
        method: 'POST',
        headers: {'Content-Type' : 'application/json'},
        body: JSON.stringify({user_id: user.id})
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert("error", errorData);
        return;
      }
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = address;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error('Error: ', error);
    }
  };


  return (
    <div>
      <h1>Your Tenancy Details</h1>

      <section>
        <h3>Address</h3>
        <p>{address}</p>
      </section>

      <section>
        <h3>Tenancy Period</h3>
        <p>Start: {tenancyStart} - End: {tenancyEnd}</p>
      </section>

      <section>
        <h3>Deposit</h3>
        <p>£{deposit} (Protected)</p>
      </section>

      <section>
        <h3>Rent</h3>
        <p>£{rent} (Paid monthly)</p>
      </section>

      <section>
        <h3>Tenancy Contract</h3>
        <button onClick={downloadFile}>Download PDF</button>
      </section>
    </div>
  );
};

export default Tenancy;
